/** Canonical copy for left-rail primary and passive empty states. */

export const railZeroStateCopy = {
  workspaces: {
    teams: {
      title: "Start a shared Workspace.",
      description: "Name it, invite the team, open a Canvas together.",
      cta: "New workspace",
    },
    myCanvas: {
      title: "Your Canvas is waiting.",
      description: "Drop files on it, or start with a blank board.",
      cta: "New Canvas",
    },
    shared: {
      title: "Nothing shared yet.",
      description: "Workspaces and Canvases others share with you land here.",
    },
  },
  files: {
    mine: {
      title: "Drop something in.",
      description: "Files live here and follow you onto the Canvas.",
      cta: "Upload files",
    },
    team: {
      title: "No team Workspaces yet.",
      description: "Create a Workspace first. Files accumulate there.",
      cta: "Go to Workspaces",
    },
    shared: {
      title: "Nothing shared yet.",
      description: "Files others share with you directly land here.",
    },
  },
  skills: {
    mine: {
      title: "Show the agent once.",
      description: "Run something twice. Then we'll suggest a Skill.",
      cta: "Add Skill",
    },
  },
  connectors: {
    all: {
      title: "Bring your tools in.",
      description:
        "Connect Slack, HubSpot, or Drive. Pull records onto the Canvas.",
      cta: "Add connector",
    },
  },
  chats: {
    all: {
      title: "What are we doing?",
      description: "Ask the agent anything in My Workspace.",
      cta: "New chat",
    },
    favorites: {
      title: "Pin what matters.",
      description: "Pin a chat and it stays here.",
    },
  },
  automations: {
    active: {
      title: "No automations yet.",
      description:
        "Ask the agent to run something on a schedule, or create one here.",
    },
    paused: {
      title: "Nothing paused.",
      description:
        "Paused automations keep their schedule until you resume them.",
    },
  },
} as const;
